import React, { useContext, useState } from 'react';

import { useAggregatedState } from '../../helpers';

export const MenuContext = React.createContext(null);

const { Provider } = MenuContext;
export const MenuProvider = ({ ...props }) => {
    const [state, setState] = useAggregatedState({
        menuIsOpen: false
    });

    const setMenuIsOpen = (isOpen) => {
        setState({ menuIsOpen: isOpen });
    }

    return (
        <Provider value={{
            state,
            setMenuIsOpen
        }}>
            {props.children}
        </Provider>
    );
}